export default __webpack_public_path__ + "static/media/Token of Torment.de57cef3.jpg";